const DISTRIBUTION = 'DISTRIBUTION';
const SINGLE_SHIPMENT = 'SINGLE_SHIPMENT';
const COLLECTION = 'COLLECTION';

const pickupStopInfo = {
  addressSuffix: 'from',
  stopPreffix: 'pickup',
  handlingExtraName: 'HANDLING_LOADING',
};
const dropoffStopInfo = {
  addressSuffix: 'to',
  stopPreffix: 'dropoff',
  handlingExtraName: 'HANDLING_UNLOADING',
};

const stopInfo = {
  [COLLECTION]: pickupStopInfo,
  [DISTRIBUTION]: dropoffStopInfo,
};

const getRepeatableStopInfo = (shipper_order_type) =>
  stopInfo[shipper_order_type] || stopInfo[DISTRIBUTION];

export {
  DISTRIBUTION,
  COLLECTION,
  SINGLE_SHIPMENT,
  pickupStopInfo,
  dropoffStopInfo,
  getRepeatableStopInfo,
};
